import React from 'react';
import { TFunction, useTranslation } from 'react-i18next';
import { Button } from '@solvhealth/jigsaw-v1';
import { ActiveBookingStates } from '~/components/AccountGetsMarried/components/GetCare/components/AccountHeadline/components/AppointmentCard/util';

type Props = {
  bookingState: number;
  disabled: boolean;
  isLoading?: boolean;
  onAppointmentCardClick: any;
};

const callToActionCopy = (bookingState: ActiveBookingStates, t: TFunction<'account'[]>) => {
  switch (bookingState) {
    case ActiveBookingStates.PreTelemedIncompleteAndEarly:
    case ActiveBookingStates.PreClinicVisitNoCheckIncomplete:
    case ActiveBookingStates.PreClinicVisitHasCheckIncompleteAndEarly:
      return t('account:appointmentCard.callToActionCopy.completePaperwork');
    case ActiveBookingStates.PreExternalTelemed:
      return t('account:appointmentCard.callToActionCopy.viewVisitDetails');
    case ActiveBookingStates.PreTelemedIncompleteAndApptSoon:
    case ActiveBookingStates.PreTelemedCompleteAndEarly:
    case ActiveBookingStates.PreTelemedCompleteAndApptSoon:
      return t('account:appointmentCard.callToActionCopy.joinWaitingRoom');
    case ActiveBookingStates.InTelemed:
      return t('account:appointmentCard.callToActionCopy.joinCall');
    case ActiveBookingStates.PreClinicVisitNoCheckComplete:
    case ActiveBookingStates.PreClinicVisitNoCheckNAPaperwork:
      return t('account:appointmentCard.callToActionCopy.manageVisit');
    case ActiveBookingStates.PreClinicVisitHasCheckCompleteOrApptSoon:
      return t('account:appointmentCard.callToActionCopy.checkIn');
    case ActiveBookingStates.InClinicVisit:
      return t('account:appointmentCard.callToActionCopy.viewSpot');
    case ActiveBookingStates.PostTelemedSummaryPending:
      return t('account:appointmentCard.callToActionCopy.saveVisitSummary');
    case ActiveBookingStates.PostTelemedSummaryDownloadable:
      return t('account:appointmentCard.callToActionCopy.saveVisitSummary');
    case ActiveBookingStates.PostTelemedSummaryUpdatable:
      return t('account:appointmentCard.callToActionCopy.updateVisitSummary');
    case ActiveBookingStates.PostTelemedSummaryViewable:
      return t('account:appointmentCard.callToActionCopy.viewVisitSummmary');
    case ActiveBookingStates.PostTelemedNoRating:
    case ActiveBookingStates.PostClinicVisitNoRating:
      return t('account:appointmentCard.callToActionCopy.rateAndReview');
    case ActiveBookingStates.PostTelemedHasRating:
    case ActiveBookingStates.PostClinicVisitHasRating:
      return t('account:appointmentCard.callToActionCopy.addVisitNotes');
    case ActiveBookingStates.PostVisitHasLabResult:
      return t('account:appointmentCard.callToActionCopy.viewTestResults');
    default:
      return t('account:appointmentCard.callToActionCopy.default');
  }
};

const AppointmentCardButton = (props: Props) => {
  const { bookingState, disabled, onAppointmentCardClick, isLoading } = props;
  const { t } = useTranslation(['account']);

  return (
    <Button
      disabled={disabled}
      loading={isLoading}
      onClick={onAppointmentCardClick}
      size="small"
      variant="outlined"
      width="100%"
    >
      {callToActionCopy(bookingState, t)}
    </Button>
  );
};

export default AppointmentCardButton;
